export enum SortDirection {
    Descending = -1,
    Ascending = 1
}

export function AlphabeticalNamedSorter(
    v1: { name: string }, 
    v2: { name: string }, 
    caseInsensitive: boolean = false, 
    direction: SortDirection = SortDirection.Ascending): number {
    
    let v1Name = v1.name || '';
    let v2Name = v2.name || '';
    
    if (caseInsensitive) {
        v1Name = v1Name.toUpperCase();
        v2Name = v2Name.toUpperCase();
    }
    
    if (v1Name > v2Name) {
        return direction * 1;
    } else if (v2Name > v1Name) {
        return direction * -1;
    } else {
        return 0;
    }
}

export function OrderFieldSorter(
    v1: { order: number }, 
    v2: {order: number }, 
    direction: SortDirection = SortDirection.Ascending) {
        
    if (v1.order > v2.order) {
        return direction * 1;
    } else if (v2.order > v1.order) {
        return direction * -1;
    } else {
        return 0;
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/sort-methods.ts